module.exports = "/_next/static/images/logo-white-dc48708d81466b42a423d6a875eaa3b6.svg";